import React from "react";

import SidebarView from './sidebar.view.component';
import SidebarHeader from './sidebar.header.component';
import SidebarColor from './sidebar.color.component';
import SidebarScenario from './sidebar.scenario.component';
import SidebarFooter from './sidebar.footer.component';
import Topbar from '../topbar/topbar.component';
import arrowBtn from '../../../assets/svgs/avatr/chevron-left.svg'

import mouse from '../../../assets/svgs/Tutorial/Icon_Mouse.svg'
import mouse_spart from '../../../assets/svgs/Tutorial/Icon_Mouse_Spark.svg'

interface Props {
  car: any;
  color: any;
  seat: string;
  scenario: any;
  isInternalView: boolean;
  showOtherMenus: boolean;
  lightsOn: boolean;
  enableAnimations: boolean;
  isCollapsed: boolean;
  audioMute: boolean;
  showGalleryMenu: boolean;

  setColor: (value: any) => void;
  setSeat: (value: string) => void;
  setScenario: (value: any) => void;
  setInternalView: (boolean: any) => void;
  setShowScreenshotMenu: (boolean: any) => void;
  setShowGaleryMenu: (boolean: any) => void;
  setShowPDFMenu: (value: boolean) => void
  setIsCollapsed: (boolean: any) => void;
  setLightsOn: (boolean: any) => void;
  setAudioMute: (boolean: any) => void;
  returnToShowroom: () => void;
}

const Sidebar: React.FC<Props> = ({ car, color, seat, scenario, isInternalView, showOtherMenus, lightsOn, enableAnimations, isCollapsed, audioMute, showGalleryMenu, setColor, setScenario, setInternalView, setShowScreenshotMenu, setShowGaleryMenu, setShowPDFMenu, setSeat, setLightsOn, setIsCollapsed, setAudioMute, returnToShowroom}) => {
  
  //const [isCollapsed, setIsCollapsed] = React.useState(true);
  const [showTutorial, setShowTutorial] = React.useState(true);

  React.useEffect(() => {
    if(!showTutorial)//
      setIsCollapsed(showOtherMenus)
  }, [showOtherMenus, showTutorial, setIsCollapsed]);

  return (
    <div className={`studio-full-siderbar ${!showOtherMenus ? '':'hide'}`}>
      <Topbar isPortrait={false} audioMute={audioMute} setAudioMute={setAudioMute} returnToShowroom={returnToShowroom}/>

      <div className={`studio-sidebar-container ${(isCollapsed) ? 'collapsed':''}`}>
        <div className="studio-sidebar-subcontainer">
          <SidebarHeader title={car.name} subtitle={car.category}/>
          {!showGalleryMenu && <SidebarView enableAnimations={enableAnimations} isInternalView={isInternalView} setInternalView={setInternalView}/>}
          {/* {!isInternalView && <SidebarLights lightsOn={lightsOn} setLightsOn={setLightsOn}/>}
          {!isInternalView && <SidebarColor car={car} color={color} setColor={setColor}/>} */}
          {isInternalView === false && !showGalleryMenu && <SidebarColor car={car} color={color} setColor={setColor}/>}
          {!showGalleryMenu && <SidebarScenario car={car} scenario={scenario} setScenario={setScenario}/>}
          {/* {isInternalView === true && <SidebarSeats car={car} enableAnimations={enableAnimations} seat={seat} setSeat={setSeat}/>} */}
          <SidebarFooter car={car} showGalleryMenu={showGalleryMenu} setShowGaleryMenu={setShowGaleryMenu} setShowPDFMenu={setShowPDFMenu}/>
        </div>

        <div className={`car-studio-collapse-container ${isCollapsed ? 'collapsed':''}`}>
          <div className={`car-studio-collapse-btn ${isCollapsed ? 'collapsed':''}`} onClick={() => {setIsCollapsed(!isCollapsed); setShowTutorial(false)}}>
            <img src={arrowBtn} alt=''/>
          </div>
          <div className={`car-studio-collapse-tutorial ${showTutorial ? '':'hide'}`}>
            <div className='collapse-animation-icon-container'>
              <img src={mouse_spart} alt='' className='collapse-icon-animation'/>
              <img src={mouse} alt='' className='collapse-icon'/>
            </div>
            <div className={`car-studio-collapse-tutorial-text`}>
              <div className='collapse-animation-text-reduced'>
                Haz clic para mostrar las configuraciones
              </div>
            </div>
          </div>
        </div>

      </div>
      
    </div>
  );
};

export default Sidebar;
